__turbopack_context__.v({
  "back": "PortalSubscriptions-module__NhB8sG__back",
  "badge": "PortalSubscriptions-module__NhB8sG__badge",
  "content": "PortalSubscriptions-module__NhB8sG__content",
  "description": "PortalSubscriptions-module__NhB8sG__description",
  "empty": "PortalSubscriptions-module__NhB8sG__empty",
  "group": "PortalSubscriptions-module__NhB8sG__group",
  "highlighted": "PortalSubscriptions-module__NhB8sG__highlighted",
  "personal": "PortalSubscriptions-module__NhB8sG__personal",
  "plan": "PortalSubscriptions-module__NhB8sG__plan",
  "plans": "PortalSubscriptions-module__NhB8sG__plans",
  "prices": "PortalSubscriptions-module__NhB8sG__prices",
  "select": "PortalSubscriptions-module__NhB8sG__select",
  "selection": "PortalSubscriptions-module__NhB8sG__selection",
});
